<p-button
  icon="fas fa-eye"
  [rounded]="true"
  [text]="true"
  [pTooltip]="l('::View')"
  tooltipPosition="left"
  (onClick)="onClick()" />
